export default {
  detail_header: 'Amount Due',
  summary_bank_title: 'Disbursement Account',
  action_repay: 'Repay ₱{amount}',
  action_repay2: 'Pay ₱{amount}',
  summary_borrowed: 'Loan Amount',
  summary_loan_interest: 'Interest',
  summary_service_fee: 'Processing Fee',
  summary_management: 'Account Maintenance Fee',
  summary_loan_term: 'Loan Term',
  summary_loan_term_days: '{day} Days',
  summary_repaid: 'Repaid',
  summary_repaid_date: 'Repayment Date',
  summary_late_fee: 'Late Fee',
  summary_overdue: 'Overdue',
  summary_schedule: 'Schedule {i}/{j}',
  late_fee: 'Late fee ₱{amount}',
  common_fee_amount: '₱{amount}',
  payment_detail: 'Handling charge ₱{amount1}. Total amount due ₱{amount2}',
  repayment_channels_code: 'Code',
  repayment_warn_info: 'Beware of scams! We only show repayment info in-app. \n' +
    'Don\'t trust messages or emails asking for QR scans or direct transfers.',
  repayment_support_platforms1: 'Supported Platforms',
  repayment_channels_account_no: 'Account No',
  repayment_channels_account_name: 'Account name',


  amount_title: 'Total bill amount',
  common_notice: 'Notice',
  tips_part_pay: 'Make sure to settle this loan on schedule, and you will be eligible to borrow up to ₱{amount} next time.',
  tips_overdue: 'To minimize the impact on your credit score, please make repayments ASAP.',
  repayment_unselect_1st_tips: 'Please make the 1st repayment first.',
  repayment_unselect_2st_tips: 'Please select at least 1 repayment period for repayment.',
  repayment_only_select_1st_tips: 'Clearing all repayments together can boost your credit score and loan amount.',
  repayment_only_select_1st_tips_left_btn: 'Not this time',
  repayment_only_select_1st_tips_right_btn: 'Repay all',
  summary_discount: 'Discount',
  summary_loan: 'Loan Details',
  summary_withdrawal: 'Withdrawal account',
  summary_withdrawal_amount: 'Withdrawal amount',




  payment_title: 'Real repayment sum',
  view_more_extension: 'View loan rollover records',
  view_more_agreement: 'View',
  tip_list_status: 'Status',
  tip_list_finished: 'Finished',
  tip_list_pending: 'Pending',
  action_renewal: 'Renewal',
  guide_content: 'First time to make repayment?',
  guide_title: 'Guide >',
  repayment_warn_title: 'Repayment Instruction',
  repayment_warn_subtitle: 'Transaction fee 20PHP per charge！',
  repayment_warn_content1: '1.To save money, one-time repayment is better.',
  repayment_support_platforms: 'Supported Platforms ({platforms})',
  repayment_channels_title: 'Channels',
  repayment_channels_bank: 'Bank',

};
